<template>
    <div data-testid="languages-filter">
        <h3>{{ $t('search.filters.languages') }}</h3>
        <div class="language-filter__subtitle" v-html="$t('search.filters.lang.subtitle')"></div>
        <CollapsibleList data-testid-prefix="languages-filter" :min-visible-items="3" :items="languages">
            <template #default="{item: language, visible}">
                <VJoyCheckbox
                    v-show="visible"
                    :checked="isChecked(language.key)"
                    :data-testid="`languages-filter-${language.key}`"
                    :label="`${language.label} (${language.count})`"
                    @update:checked="toggleFilter(language.key)"
                />
            </template>
        </CollapsibleList>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import CollapsibleList from '~/components/common/CollapsibleList.vue';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    const languages = computed(() => availableSearchFilters.value?.languages ?? []);

    function isChecked(languageFilter: string) {
        return filtersStore.isFilterChecked('languages', languageFilter);
    }

    function toggleFilter(languageFilter: string) {
        filtersStore.toggleFilter('languages', languageFilter);
    }
</script>

<style lang="scss" scoped>
    .language-filter {
        &__subtitle {
            display: block;
            font-size: small;
            margin-bottom: var(--joy-core-spacing-5);
        }
    }
</style>
